import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { showAlertModal } from '../../../../actions';
import { formatDisplayTS } from '../../../common/Utilities';
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';
import ConfigForm from '../config/ConfigForm';

class CameraForm extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      bID: '',
      name: '',
      config: {},
      cameraEdit: false,
      showConfirmSave: false,
      reloadConfig: false,
    }
  }

  componentDidMount(){
    if (this.props.camera) {
      // we are editing a camera
      this.setState({
        bID: this.props.camera.bID,
        name: this.props.camera.sName,
        config: JSON.parse(JSON.stringify(this.props.camera.sConfig)),
        cameraEdit: true,
        showConfirmSave: false,
        reloadConfig: false,
      })
    }
  }

  componentDidUpdate() {
    if(this.props.camera && this.props.camera.bID && this.props.camera.bID !== this.state.bID){
      this.setState({
        bID: this.props.camera.bID,
        name: this.props.camera.sName,
        config: {},
        cameraEdit: true,
        showConfirmSave: false,
        reloadConfig: true,
      })
    }
  }

  handleChange = (e, type) => {
    this.setState({ [type]: e.target.value });
  }

  handleConfigChanges = (type, value) => {
    this.setState({[type]: value})
  }

  handleConfigReload = () => {
    this.setState({config: JSON.parse(JSON.stringify(this.props.camera.sConfig))})
  }

  onSubmit = async() => {
    if(this.state.name.length < 1 ) {
      this.props.showAlertModal(['WARNING', 'Camera name must be provided. Please revise.'])
      return
    }

    // not all devices have config data, only check if there are empty config fields if they had one in the first place
    const emptyConfigs = Object.keys(this.state.config).length && this.state.config['camera' + this.props.camera.bCamera]
      ? Object.entries(this.state.config['camera' + this.props.camera.bCamera]).find(([_, value]) => value === '') : false
    if (emptyConfigs) {
      this.props.showAlertModal(['WARNING', 'All device configs are required. Please revise.'])
      return
    }

    this.setState({showConfirmSave: true})
  }

  onSave = async () => {
    this.setState({showConfirmSave: false})

    const reqBody = {
      "id": this.props.camera.bID,
      "name": this.state.name,
      "deviceId": this.props.camera.sDeviceID,
      "bCamera": this.props.camera.bCamera,
      "config": this.state.config,
    }

    await axios({
      method: 'post',
      url: this.props.cloudAPI + 've/camera?device=' + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'Camera details successfully saved.'])
      this.props.updateData('camera', {
        bID: this.props.camera.bID,
        sName: this.state.name,
        sConfig: this.state.config,
      });
      this.setState({reloadConfig: true})

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to save camera details.'])
    })
  }

  cancelSave = () => {
    document.getElementById('form-wrapper').focus()
    this.setState({showConfirmSave: false})
  }

  undoEdit = () => {
    this.setState({
      bID: this.props.camera.bID,
      name: this.props.camera.sName,
      cameraEdit: true,
      showConfirmSave: false,

      // this is for handling config change
      // JS does not detect multi-level object changes, so we have to explicitly change the object (in our case, we emptied it out) then update it later with the new value
      // so React can say that {} != {some object content} and re-render
      config: {},
      reloadConfig: true,
    });
  }

  onBlur = (e) => {
    if (this.props.camera) {
      if ((this.state.name !== this.props.camera.sName)
        || (JSON.stringify(this.state.config) !== JSON.stringify(this.props.camera.sConfig))) {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    const confirmMessage = (
      <div>
        <p>Are you sure you want to save the changes?</p>
        <p>Note that this cannot be undone and changes you made will update the camera and all its related components (views).</p>
        <p style={{fontWeight: 'bold'}}>Would you like to proceed?</p>
      </div>
    )

    return (
      <FormWrapper
        heading={"Edit Camera"}
        onBlur={this.onBlur}
        closeForm={this.props.closeForm}
        onSubmit={this.onSubmit}
        edit={this.state.cameraEdit}
        undoEdit={this.undoEdit} >

        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Name:</p>
            <input
              name="name"
              type="text"
              value={this.state.name}
              style={{ fontSize: '1.6vmin', width: '50%' }}
              onChange={(e) => this.handleChange(e, 'name')} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Customer:</p>
            <input
              name="customerName"
              type="text"
              value={this.props.camera.sCustomerName}
              disabled
              style={{ fontSize: '1.6vmin', width: '50%' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Site:</p>
            <input
              name="siteName"
              type="text"
              value={this.props.camera.sProjectName}
              disabled
              style={{ fontSize: '1.6vmin', width: '50%' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Device:</p>
            <input
              name="deviceName"
              type="text"
              value={this.props.camera.sDeviceName}
              disabled
              style={{ fontSize: '1.6vmin', width: '50%' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Enabled:</p>
            <input
              name="enabled"
              type="text"
              value={this.props.camera.fEnabled ? 'yes' : 'no'}
              disabled
              style={{ fontSize: '1.6vmin', width: '50%' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '1vmin', marginBottom: '1.6vmin', marginRight: '1vmin' }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Online:</p>
            <input
              name="online"
              type="text"
              value={this.props.camera.fOnline ? 'yes' : 'no'}
              disabled
              style={{ fontSize: '1.6vmin', width: '50%' }} />
          </div>

          <div style={{ padding: '1vmin', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div style={{ width: '45%', backgroundColor: 'lightgrey', borderRadius: 5, padding: '1vmin' }}>
              <p style={{ fontSize: '1.6vmin', margin: 0, textAlign: 'center', marginBottom: '1.3vmin', textDecoration: 'underline' }}>Profile 1</p>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '1vmin' }}>
                <p style={{ margin: 0, fontSize: '1.4vmin', marginBottom: '1vmin' }}>Bitrate:</p>
                <input
                  name="deviceName"
                  type="text"
                  value={this.props.camera.bBitrate1}
                  disabled
                  style={{ fontSize: '1.4vmin', textAlign: 'center', width: '100%' }} />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '2vmin' }}>
                <p style={{ margin: 0, fontSize: '1.4vmin', marginBottom: '1vmin' }}>Last Request TS:</p>
                <input
                  name="deviceName"
                  type="text"
                  value={this.props.camera.convertedTS1 ? formatDisplayTS(this.props.camera.convertedTS1, true) : (this.props.camera.sLastRequestTS1 ? formatDisplayTS(this.props.camera.sLastRequestTS1, false) : '')}
                  disabled
                  style={{ fontSize: '1.4vmin', textAlign: 'center', width: '100%' }} />
              </div>

            </div>
            <div style={{ width: '45%', backgroundColor: 'lightgrey', borderRadius: 5, padding: '1vmin' }}>
              <p style={{ fontSize: '1.6vmin', margin: 0, textAlign: 'center', marginBottom: '1.3vmin', textDecoration: 'underline' }}>Profile 2</p>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '1vmin' }}>
                <p style={{ margin: 0, fontSize: '1.4vmin', marginBottom: '1vmin' }}>Bitrate:</p>
                <input
                  name="deviceName"
                  type="text"
                  value={this.props.camera.bBitrate2}
                  disabled
                  style={{ fontSize: '1.4vmin', textAlign: 'center', width: '100%' }} />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '2vmin'}}>
                <p style={{ margin: 0, fontSize: '1.4vmin', marginBottom: '1vmin'  }}>Last Request TS:</p>
                <input
                  name="deviceName"
                  type="text"
                  value={this.props.camera.convertedTS2 ? formatDisplayTS(this.props.camera.convertedTS2, true) : (this.props.camera.sLastRequestTS2 ? formatDisplayTS(this.props.camera.sLastRequestTS2, false) : '')}
                  disabled
                  style={{ fontSize: '1.4vmin', textAlign: 'center', width: '100%' }} />
              </div>

            </div>
          </div>
        </div>

        <ConfigForm
          deviceId={this.props.camera.sDeviceID}
          cameraId={this.props.camera.bCamera}
          config={this.state.config}
          reloadConfig={this.state.reloadConfig}
          handleConfigChanges={this.handleConfigChanges}
          handleConfigReload={this.handleConfigReload} />

        {this.state.showConfirmSave &&
          <Dialog
            overlayStyle = {{zIndex: 1000}}
            title = "WARNING"
            content = {confirmMessage}
            buttons={[
              {label: 'Yes', onClick: this.onSave},
              {label: 'Cancel', onClick: this.cancelSave}
            ]}
          />
        }
      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
export default connect(mapStateToProps, { showAlertModal } )(CameraForm);